'use client';

import React, { useEffect, useRef, useState } from 'react';
import { Form, Input, Button, Spin, Typography, App } from 'antd';
import { useRouter } from 'next/navigation';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { useTranslations } from 'next-intl';

import { isValidPhoneNumber } from 'libphonenumber-js';
import PhoneInput from 'antd-phone-input';
import { loginWithAllAccessTypeAction } from '@/serverActions/authAction/loginWithAllAccessTypeAction';
import { getHostThemeByHostNameAction } from '@/serverActions/themeAction/queries/getHostThemeByHostNameAction';
import { useTheme } from '../ThemeComponents/ThemeProvider';
import Image from 'next/image';
import dayjs from 'dayjs';
import { formatLocalizedDate } from '@/utils/formatLocalizedDate';

interface WelComeProps {
  onLogin: () => void;
  onRegister: () => void;
}

interface EmailFormProps {
  onEmailSubmit: (email: string) => void;
  onPhoneNumberSubmit: (countryCode: string, phoneNumber: string) => void;
  onGoBackToWelcome: () => void;
}

interface PasswordFormProps {
  email: string;
  input: 'username' | 'phone';
  countryCode: string;
  phoneNumber: string;
  onPasswordSubmit: (password: string) => void;
  onForgotPassword: () => void;
  onBackToLogIn: () => void;
}

interface ForgotPasswordFormProps {
  onForgotPasswordEmailSubmit: (email: string) => void;
  onBackToLogIn: () => void;
}

interface OTPFormProps {
  email: string;
  onOTPSubmit: (otp: string) => void;
  onBackToLogIn: () => void;
}

interface ResetPasswordFormProps {
  email: string;
  onResetSubmit: (newpassword: string) => void;
  onBackToLogIn: () => void;
}

const Welcome: React.FC<WelComeProps> = ({ onLogin, onRegister }) => {
  const t = useTranslations('login');
  // const [themeData, setThemeData] = useState<any>(null);

  // useEffect(() => {
  //   const dataTheme = localStorage.getItem('hostTheme');
  //   if (dataTheme) {
  //     setThemeData(JSON.parse(dataTheme));
  //   }
  // }, []);

  const themeData = useTheme();
  const color1 = themeData?.theme?.calVariable?.primaryColor;
  const color2 = themeData?.theme?.calVariable?.secondaryColor;

  if (!themeData) {
    return (
      <div style={{ textAlign: 'center', padding: 50 }}>
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div className="w-[532px] pl-[48px] pr-[48px]">
      {/* <div
        className={`flex justify-left text-4xl font-bold mb-8`}
        style={{ color: color1 }}
      >
        {themeData?.application?.appName}
      </div> */}
      <div className="flex flex-col">
        <Button
          onClick={onLogin}
          type="primary"
          style={{
            fontSize: '24px',
            padding: '32px 0 32px 0',
            borderRadius: '15px',
            boxShadow: '20',
          }}
        >
          {t('login')}
        </Button>
        {/* <Button
          onClick={onRegister}
          disabled
          style={{
            // background: 'linear-gradient(#1D34FF, #00FFF5)',
            // color: '#fff',
            background: '#E5E5E5',
            color: 'grey',
            fontSize: '36px',
            padding: '32px 0 32px 0',
            borderRadius: '15px',
            height: '108px',
            marginTop: '16px',
            border: 0,
          }}
        >
          {t('register')}
        </Button> */}
      </div>
    </div>
  );
};

const EmailForm: React.FC<EmailFormProps> = ({
  onEmailSubmit,
  onPhoneNumberSubmit,
  onGoBackToWelcome,
}) => {
  const [form] = Form.useForm();
  const t = useTranslations('login');
  const [input, setInput] = useState('username');
  const themeData = useTheme();
  const color1 = themeData?.theme?.calVariable?.primaryColor;
  const color2 = themeData?.theme?.calVariable?.secondaryColor;
  const { Text, Title } = Typography;
  const handleFinish = () => {
    form
      .validateFields()
      .then((values) => {
        if (input === 'username') {
          onEmailSubmit(values.email);
        } else {
          const countryCode = `${values?.phoneNumber?.countryCode}`;
          const number = `${values?.phoneNumber?.areaCode}${values?.phoneNumber?.phoneNumber}`;

          onPhoneNumberSubmit(countryCode, number);
        }
      })
      .catch((info) => {
        console.error('Validate Failed:', info);
      });
  };

  return (
    <div className="bg-white w-[532px] pl-[48px] pr-[48px]">
      <div
        className="flex justify-center text-4xl font-bold pt-[48px] pb-[48px]"
        style={{ color: color1 }}
      >
        <Title style={{ color: color1 }} level={2}>
          {t('login')}
        </Title>
      </div>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleFinish}
        scrollToFirstError
      >
        {input === 'username' ? (
          <>
            {' '}
            <div className="" style={{ color: color1 }}>
              {t('userEmail')}
            </div>
            <Form.Item
              name="email"
              rules={[{ required: true, message: t('enterUserEmail') }]}
            >
              <Input
                style={{ borderRadius: '1px', width: '100%' }}
                placeholder={t('provideUserEmail')}
              />
            </Form.Item>
            <a
              onClick={() => setInput('phone')}
              className="underline hover:underline"
              style={{ color: color1 }}
            >
              {t('usePhoneNumberForLogin')}
            </a>
          </>
        ) : (
          <>
            <div className="" style={{ color: color1 }}>
              {t('phoneNumber')}
            </div>
            <Form.Item
              name="phoneNumber"
              rules={[
                {
                  // validator: (_, { valid }) => {
                  //   // `valid()` จะคืนค่า true ถ้าเบอร์โทรถูกต้อง
                  //   // `valid(true)` จะคืนค่า true ถ้าเบอร์โทรถูกต้องแบบ strict (รวม dial/area codes)
                  //   if (valid()) {
                  //     return Promise.resolve();
                  //   }
                  //   return Promise.reject(new Error(t('invalidPhoneNumber')));
                  // },
                  validator: (_, value) => {
                    // `value` คือ object ที่มาจาก antd-phone-input
                    // เราจะเช็ค `value.phoneNumber` ว่ามีค่าหรือไม่
                    if (!value || !value.phoneNumber) {
                      return Promise.reject(new Error(t('enterPhoneNumber')));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <PhoneInput
                placeholder={t('providePhoneNumber')}
                style={{ borderRadius: '1px' }}
                enableSearch
              />
            </Form.Item>
            <a
              onClick={() => setInput('username')}
              className="underline hover:underline"
              style={{ color: color1 }}
            >
              {t('useUsernameForLogin')}
            </a>
          </>
        )}

        <div className="h-[54px]"></div>
        <div className="flex justify-between">
          <a
            onClick={onGoBackToWelcome}
            style={{
              borderRadius: '1px',
              padding: '8px 16px',
              width: 112,
              color: color1,
            }}
          >
            {t('goBack')}
          </a>
          <Form.Item className="flex justify-end">
            <Button
              size="middle"
              style={{ borderRadius: '1px', padding: '8px 16px', width: 112 }}
              type="primary"
              htmlType="submit"
            >
              {t('next')}
            </Button>
          </Form.Item>
        </div>
      </Form>
      <div className="flex justify-center py-6" style={{}}>
        <a className="text-sm" style={{ color: color1 }}>
          <Text style={{ color: color1 }}>{t('contactCustomerService')}</Text>
        </a>
      </div>
    </div>
  );
};

const PasswordForm: React.FC<PasswordFormProps> = ({
  email,
  countryCode,
  phoneNumber,
  input,
  onPasswordSubmit,
  onForgotPassword,
  onBackToLogIn,
}) => {
  const [form] = Form.useForm();
  const t = useTranslations('login');
  const themeData = useTheme();
  const color1 = themeData?.theme?.calVariable?.primaryColor;
  const color2 = themeData?.theme?.calVariable?.secondaryColor;
  const { Text, Title } = Typography;
  const handleLogin = () => {
    form
      .validateFields()
      .then((values) => {
        onPasswordSubmit(values.password);
      })
      .catch((info) => {
        console.error('Validate Failed:', info);
      });
  };

  const passwordRef = useRef<any>(null);

  useEffect(() => {
    passwordRef.current?.focus();
  }, []);

  return (
    <div className="bg-white w-[532px] pl-[48px] pr-[48px]">
      <div
        className="flex justify-center text-4xl font-bold pt-[48px] pb-[48px]"
        style={{ color: color1 }}
      >
        <Title style={{ color: color1 }} level={2}>
          {t('login')}
        </Title>
      </div>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleLogin}
        scrollToFirstError
      >
        {input === 'username' ? (
          <>
            <div className="" style={{ color: color1 }}>
              {t('userEmail')}
            </div>
            <Form.Item
              name="emaildata"
              initialValue={email}
              rules={[{ required: true, message: t('enterUserEmail') }]}
            >
              <Input
                disabled
                style={{ borderRadius: '1px', width: '100%' }}
                placeholder={t('provideUserEmail')}
              />
            </Form.Item>
          </>
        ) : (
          <>
            <div className="" style={{ color: color1 }}>
              {t('phoneNumber')}
            </div>
            <Form.Item
              name="phoneNumber"
              rules={[{ required: true, message: t('enterPhoneNumber') }]}
              initialValue={{
                countryCode: parseInt(countryCode),
                phoneNumber: phoneNumber,
              }}
            >
              <PhoneInput
                disabled
                placeholder={t('providePhoneNumber')}
                style={{ borderRadius: '1px' }}
                enableSearch
              />
            </Form.Item>
          </>
        )}

        <div className="flex justify-between " style={{ color: color1 }}>
          <p>{t('password')}</p>
          {/* <a onClick={onForgotPassword} style={{ color: '#ef5da8' }}>
            ลืมรหัสผ่าน?
          </a> */}
        </div>
        <Form.Item
          name="password"
          rules={[{ required: true, message: t('enterPassword') }]}
        >
          <Input.Password
            autoFocus
            style={{ borderRadius: '1px', width: '100%' }}
          />
        </Form.Item>
        <div className="flex justify-between">
          <a
            className=""
            onClick={onBackToLogIn}
            style={{
              borderRadius: '1px',
              padding: '8px 16px',
              width: 112,
              color: color1,
            }}
          >
            {t('goBack')}
          </a>
          <Form.Item className="flex justify-end">
            <Button
              size="middle"
              style={{ borderRadius: '1px', padding: '8px 16px', width: 112 }}
              type="primary"
              htmlType="submit"
            >
              {t('login')}
            </Button>
          </Form.Item>
        </div>
      </Form>
      <div className="flex justify-center py-6" style={{}}>
        <a className="text-sm">
          <Text style={{ color: color1 }}>{t('contactCustomerService')}</Text>
        </a>
      </div>
    </div>
  );
};

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  onForgotPasswordEmailSubmit,
  onBackToLogIn,
}) => {
  const [form] = Form.useForm();
  const t = useTranslations('login');
  const themeData = useTheme();
  const color1 = themeData?.theme?.calVariable?.primaryColor;
  const color2 = themeData?.theme?.calVariable?.secondaryColor;
  const handleSentOTP = () => {
    form
      .validateFields()
      .then((values) => {
        onForgotPasswordEmailSubmit(values.email);
      })
      .catch((info) => {
        console.error('Validate Failed:', info);
      });
  };

  return (
    <div>
      <div className="flex justify-center text-2xl">{t('forgotpass')}</div>
      <div className="flex justify-center text-2xl">{t('forgotmail')}</div>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSentOTP}
        style={{ marginTop: '2rem' }}
        scrollToFirstError
      >
        <Form.Item
          label={t('emailLabel')}
          name="email"
          rules={[{ required: true, message: t('emailmes') }]}
        >
          <Input
            style={{ borderRadius: '1px', minWidth: '450px' }}
            placeholder={t('emailLabel')}
          />
        </Form.Item>
        <Form.Item className="flex justify-center">
          <Button
            className="m-6"
            style={{ borderRadius: '1px', minWidth: '400px' }}
            type="primary"
            htmlType="submit"
          >
            {t('next')}
          </Button>
        </Form.Item>
        <p className="text-center">
          <a onClick={onBackToLogIn} style={{ color: color1 }}>
            {t('backToLoginPage')}
          </a>
        </p>
      </Form>
    </div>
  );
};

const OTPForm: React.FC<OTPFormProps> = ({
  email,
  onOTPSubmit,
  onBackToLogIn,
}) => {
  const [form] = Form.useForm();
  const t = useTranslations('login');

  const handleSubmitOTP = () => {
    form
      .validateFields()
      .then((values) => {
        onOTPSubmit(values.otp);
      })
      .catch((info) => {
        console.error('Validate Failed:', info);
      });
  };

  return (
    <div>
      <div className="flex justify-center text-2xl">{t('enterOTP')}</div>
      <div className="flex justify-center">
        {t('otpSentTo')} {email}
      </div>
      <div className="flex justify-center">
        {t('referenceCode')} -{'1S13A'}
      </div>
      <Form
        form={form}
        onFinish={handleSubmitOTP}
        style={{ marginTop: '2rem' }}
        scrollToFirstError
      >
        <Form.Item
          className="flex justify-center"
          name="otp"
          rules={[{ required: true, message: t('enterOTPCode') }]}
        >
          <Input.OTP size="large" length={6} />
        </Form.Item>
        <div className="flex justify-center">{'00.58'}</div>
        <div className="flex justify-center">
          <a className="text-gray-400">{t('resendOTP')}</a>
        </div>
        <Form.Item>
          <Button
            className="m-6"
            style={{ borderRadius: '1px', minWidth: '400px' }}
            type="primary"
            htmlType="submit"
          >
            {t('next')}
          </Button>
        </Form.Item>
        <div className="flex justify-center">
          <a
            className="text-gray-400 underline text-lg"
            style={{ color: '#ef5da8' }}
          >
            {t('contactSupport')}
          </a>
        </div>
        <div className="flex justify-center m-6">
          <a
            className="text-gray-400 text-base"
            style={{ color: '#ef5da8' }}
            onClick={onBackToLogIn}
          >
            {t('backToLoginPage')}
          </a>
        </div>
      </Form>
    </div>
  );
};

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({
  email,
  onResetSubmit,
  onBackToLogIn,
}) => {
  const [form] = Form.useForm();
  const t = useTranslations('login');

  const handleSubmitNewPass = () => {
    form
      .validateFields()
      .then((values) => {
        onResetSubmit(values.newpassword);
      })
      .catch((info) => {
        console.error('Validate Failed:', info);
      });
  };

  return (
    <div>
      <div className="flex justify-center text-2xl">{t('resetPassword')}</div>
      <div className="flex justify-center mt-6">{t('enterNewPassword')}</div>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmitNewPass}
        style={{ marginTop: '2rem' }}
        scrollToFirstError
      >
        <div>{t('newPassword')}</div>
        <Form.Item
          name="newpassword"
          rules={[
            {
              required: true,
              message: t('enterNewPassword'),
            },
          ]}
          hasFeedback
        >
          <Input.Password style={{ borderRadius: '1px' }} />
        </Form.Item>
        <div>{t('confirmNewPassword')}</div>
        <Form.Item
          name="confirm"
          dependencies={['newpassword']}
          hasFeedback
          rules={[
            {
              required: true,
              message: t('confirmPassword'),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newpassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('invalidPassword')));
              },
            }),
          ]}
        >
          <Input.Password style={{ borderRadius: '1px' }} />
        </Form.Item>
        <Form.Item>
          <Button
            className="m-6"
            style={{ borderRadius: '1px', minWidth: '400px' }}
            type="primary"
            htmlType="submit"
          >
            {t('resetPasswordButton')}
          </Button>
        </Form.Item>

        <div className="flex justify-center m-6">
          <a
            className="text-gray-400 text-base"
            style={{ color: '#ef5da8' }}
            onClick={onBackToLogIn}
          >
            {t('backToLoginPage')}
          </a>
        </div>
      </Form>
    </div>
  );
};

function AuthLoginForm() {
  const [currentStep, setCurrentStep] = useState(0);
  const [page, setPage] = useState('welcome');
  const [email, setEmail] = useState<string>('');
  const [countryCode, setCountryCode] = useState<string>('');
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [input, setInput] = useState<'username' | 'phone'>('username');
  const [isTransitioning, setIsTransitioning] = useState(false);

  const { message } = App.useApp();

  const t = useTranslations('login');

  // useEffect(() => {
  //   message.info('welcome to Gumon Admin');
  // }, []);
  // useEffect(() => {
  //   const fetch = async () => {
  //     try {
  //       const hostTheme = await getHostThemeByHostNameAction();
  //       localStorage.setItem('hostTheme', JSON.stringify(hostTheme));
  //     } catch (error) {
  //       console.error('Error fetching host theme:', error);
  //     }
  //   };
  //   fetch();
  // }, []);

  const containerStyle: React.CSSProperties = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
  };

  const transitionStyle: React.CSSProperties = {
    opacity: isTransitioning ? 0 : 1,
    transition: 'opacity 0.2s ease-in-out',
    width: '100%',
    height: '100%',
  };
  const handleTransition = (callback: () => void) => {
    setIsTransitioning(true);
    setTimeout(() => {
      callback();
      setIsTransitioning(false);
    }, 200); // ระยะเวลา transition (ต้องตรงกับใน style)
  };
  const handleGoToLogin = () => handleTransition(() => setPage('login'));

  const handleGoToRegister = () => handleTransition(() => setPage('register'));
  const handleGoToWelcome = () => handleTransition(() => setPage('welcome'));

  const handleEmailSubmit = async (email: string) => {
    // const emailExists = await checkEmail(email);
    setEmail(email);
    setInput('username');
    setCurrentStep(1);
    // handleTransition(() => setCurrentStep(1));

    // if (emailExists) {
    //   setEmail(email);
    //   setCurrentStep(3);
    // } else {
    //   message.error('อีเมลนี้ไม่มีอยู่ในระบบ');
    // }
  };

  const handlePhoneNumberSubmit = async (
    countryCode: string,
    phoneNumber: string,
  ) => {
    // const emailExists = await checkEmail(email);
    setCountryCode(countryCode);
    setPhoneNumber(phoneNumber);
    setInput('phone');
    setCurrentStep(1);
    // handleTransition(() => setCurrentStep(1));

    // if (emailExists) {
    //   setEmail(email);
    //   setCurrentStep(3);
    // } else {
    //   message.error('อีเมลนี้ไม่มีอยู่ในระบบ');
    // }
  };

  const handleForgotPasswordEmailSubmit = async (email: string) => {
    // const emailExists = await checkEmail(email);
    setEmail(email);
    setCurrentStep(3);
    // if (emailExists) {
    //   setEmail(email);
    //   setCurrentStep(3);
    // } else {
    //   message.error('อีเมลนี้ไม่มีอยู่ในระบบ');
    // }
  };

  const router = useRouter();

  const [error, setError] = useState<string | null>(null);
  const handlePasswordSubmit = async (password: string) => {
    if (email && email !== '') {
      const token = await loginWithAllAccessTypeAction({
        username: email,
        password: password,
      });

      if (!token.success) {
        let errorMessage = token.message;
        const startLock = token.extensions?.lockAt;
        const endLock = token.extensions?.lockEnd;
        switch (errorMessage) {
          case 'username or password not match':
            errorMessage = t('incorrectUsernameOrPassword');
            break;
          case 'User is lock': {
            let countdown = '';
            if (endLock) {
              const now = dayjs();
              const end = dayjs(endLock as string);
              const diff = end.diff(now, 'second');
              if (diff > 0) {
                const hours = Math.floor(diff / 3600);
                const minutes = Math.floor((diff % 3600) / 60);
                const seconds = diff % 60;
                countdown =
                  `${hours.toString().padStart(2, '0')}:` +
                  `${minutes.toString().padStart(2, '0')}:` +
                  `${seconds.toString().padStart(2, '0')}`;
              } else {
                countdown = '00:00:00';
              }
            }
            errorMessage =
              t('userIsLocked') +
              'ถึง: ' +
              formatLocalizedDate(endLock as string, 'DD MMMM YYYY, HH:mm') +
              ' ' +
              'เหลือเวลา: ' +
              countdown;
            break;
          }
          case 'User not found!':
            errorMessage = t('userNotFound');
            break;
          default:
            errorMessage = token.message;
            // default message
            break;
        }
        message.error(t('loginFailed') + ', ' + errorMessage);
        console.error('Login failed:', errorMessage);
        return;
      }
      // ถ้าสำเร็จ
      message.success(t('loginSuccess'));
      if (token.defaultOrganizationKey) {
        router.push(`/app/my-org`);
      } else {
        router.push('/app/my-org');
      }
      return;
    }
    if (
      countryCode &&
      phoneNumber &&
      countryCode !== '' &&
      phoneNumber !== ''
    ) {
      const token = await loginWithAllAccessTypeAction({
        username: phoneNumber,
        password: password,
        countryCode: `+${countryCode}`,
      });

      if (!token.success) {
        let errorMessage = token.message;
        const startLock = token.extensions?.lockAt;
        const endLock = token.extensions?.lockEnd;
        switch (errorMessage) {
          case 'username or password not match':
            errorMessage = t('incorrectPhoneNumberOrPassword');
            break;
          case 'User is lock': {
            let countdown = '';
            if (endLock) {
              const now = dayjs();
              const end = dayjs(endLock as string);
              const diff = end.diff(now, 'second');
              if (diff > 0) {
                const hours = Math.floor(diff / 3600);
                const minutes = Math.floor((diff % 3600) / 60);
                const seconds = diff % 60;
                countdown =
                  `${hours.toString().padStart(2, '0')}:` +
                  `${minutes.toString().padStart(2, '0')}:` +
                  `${seconds.toString().padStart(2, '0')}`;
              } else {
                countdown = '00:00:00';
              }
            }
            errorMessage =
              t('userIsLocked') +
              'ถึง: ' +
              formatLocalizedDate(endLock as string, 'DD MMMM YYYY, HH:mm') +
              ' ' +
              'เหลือเวลา: ' +
              countdown;
            break;
          }
          case 'User not found!':
            errorMessage = t('userNotFound');
            break;
          default:
            errorMessage = token.message;
            // default message
            break;
        }
        message.error(t('loginFailed') + ', ' + errorMessage);
        console.error('Login failed:', errorMessage);
        return;
      }
      // ถ้าสำเร็จ
      message.success(t('loginSuccess'));
      if (token.defaultOrganizationKey) {
        router.push(`/app/my-org`);
      } else {
        router.push('/app/my-org');
      }

      return;
    }
  };

  const handleForgotPassword = () => {
    setCurrentStep(2);
  };
  const handleBackToLogIn = () => {
    // handleTransition(() => setCurrentStep(0));
    setEmail('');
    setCountryCode('');
    setPhoneNumber('');

    setCurrentStep(0);
  };

  const handleOTPSubmit = () => {
    setCurrentStep(4);
  };

  const handleNewPasswordSubmit = () => {
    setCurrentStep(0);
  };

  // const checkEmail = async (email: string): Promise<boolean> => {
  //   // ตรวจสอบอีเมลจากระบบ (API call mock)
  //   const mockExistingEmails = ['gumon@gmail.com'];
  //   return mockExistingEmails.includes(email);
  // };

  const getCurrentComponent = () => {
    if (page === 'welcome') {
      return (
        <Welcome onLogin={handleGoToLogin} onRegister={handleGoToRegister} />
      );
    }
    if (currentStep === 0 && page === 'login') {
      return (
        <EmailForm
          onEmailSubmit={handleEmailSubmit}
          onPhoneNumberSubmit={handlePhoneNumberSubmit}
          onGoBackToWelcome={handleGoToWelcome}
        />
      );
    }
    if (currentStep === 1) {
      return (
        <PasswordForm
          email={email}
          countryCode={countryCode}
          phoneNumber={phoneNumber}
          input={input}
          onPasswordSubmit={handlePasswordSubmit}
          onForgotPassword={handleForgotPassword}
          onBackToLogIn={handleBackToLogIn}
        />
      );
    }
    if (currentStep === 2) {
      return (
        <ForgotPasswordForm
          onForgotPasswordEmailSubmit={handleForgotPasswordEmailSubmit}
          onBackToLogIn={handleBackToLogIn}
        />
      );
    }
    if (currentStep === 3) {
      return (
        <OTPForm
          email={email}
          onOTPSubmit={handleOTPSubmit}
          onBackToLogIn={handleBackToLogIn}
        />
      );
    }
    return (
      <ResetPasswordForm
        email={email}
        onResetSubmit={handleNewPasswordSubmit}
        onBackToLogIn={handleBackToLogIn}
      />
    );
  };

  return (
    <div style={{ margin: '0 auto', padding: '2rem' }}>
      <div style={containerStyle}>
        <div style={transitionStyle}>{getCurrentComponent()}</div>
      </div>
    </div>
  );
}

export default AuthLoginForm;
